import React, { useState, useEffect } from "react";
import { BASE_URL } from "utils/constant";
import { auth } from "utils/firebase";

const LinkPreview = ({ url }) => {
    const [previewData, setPreviewData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchPreview = async () => {
            try {
                const token = localStorage.getItem("access");
                if (!token) {
                    console.error("No auth token available");
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}/core/link-preview/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ url }),
                });

                if (response.ok) {
                    const json = await response.json();
                    if (json.status && json.data) {
                        setPreviewData(json.data);
                    } else {
                        setError(true);
                    }
                } else {
                    setError(true);
                }
            } catch (err) {
                console.error("Error fetching link preview:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        if (url) {
            fetchPreview();
        }
    }, [url]);

    if (loading) return <div className="text-xs text-gray-500 mt-1">Loading preview...</div>;
    if (error || !previewData) return null;

    const { title, description, image, favicon, url: fetchedUrl } = previewData;
    const displayImage = image || favicon;

    return (
        <a
            href={fetchedUrl || url}
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-2 border rounded-lg overflow-hidden bg-white hover:bg-gray-50 transition-colors no-underline max-w-sm"
            onClick={(e) => e.stopPropagation()}
        >
            {displayImage && (
                <div className="h-32 w-full overflow-hidden bg-gray-100">
                    <img
                        src={displayImage}
                        alt={title}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
            )}
            <div className="p-3">
                <h3 className="text-sm font-semibold text-gray-900 line-clamp-1 mb-1">
                    {title}
                </h3>
                <p className="text-xs text-gray-600 line-clamp-2 mb-1">
                    {description}
                </p>
                <div className="text-[10px] text-gray-400 truncate">
                    {new URL(url).hostname}
                </div>
            </div>
        </a>
    );
};

export default LinkPreview;
